module.exports = __webpack_public_path__ + "static/img/sponsor_chat.ddf71dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/sponsor_chat.png
// module id = eiL+
// module chunks = 17